<template>
  <div class="space-y-2">
    <div v-if="title" class="text-md font-semibold text-gray-800 mb-2">{{ title }}</div>
    <div v-if="attributesList && attributesList.length > 0">
      <ChipListDisplay :items="attributesList" :emptyText="emptyText" />
    </div>
    <div v-else-if="typeof attributes === 'object' && attributes !== null && Object.keys(attributes).length > 0">
      <RichObjectDisplay :data="attributes" />
    </div>
    <div v-else class="text-sm text-gray-500 italic">
      {{ emptyText }}
    </div>
  </div>
</template>

<script>
import ChipListDisplay from './ChipListDisplay.vue';
import RichObjectDisplay from '../RichObjectDisplay.vue'; // Assuming RichObjectDisplay is in parent folder

export default {
  name: 'AttributesDisplay',
  components: {
    ChipListDisplay,
    RichObjectDisplay
  },
  props: {
    attributes: { // Can be an array of strings/objects, or an object
      type: [Array, Object],
      default: () => []
    },
    title: {
      type: String,
      default: 'Attributes'
    },
    emptyText: {
      type: String,
      default: 'No attributes specified'
    }
  },
  computed: {
    attributesList() {
      if (Array.isArray(this.attributes)) {
        return this.attributes.map(attr => {
          if (typeof attr === 'object' && attr !== null && attr.displayName) {
            return attr.displayName;
          }
          if (typeof attr === 'object' && attr !== null && attr.name) {
            return attr.name;
          }
          return attr.toString();
        });
      }
      return null; // If it's an object, RichObjectDisplay will handle it
    }
  }
};
</script>

<style scoped>
/* Scoped styles */
</style> 